const parse = require('./parse');
const beautify = require('./beautify');


class CustomJSON {
    static parse(string) {
        return parse(string);
    }

    static beautify(json, comments = {}, replacer = null, space = 2) {
        return beautify(json, comments, replacer, space);
    }
}

module.exports = {
    CustomJSON
};